@if (isEditable) {
<div class="row align-items-baseline sas-label-value-editable">
  <div class="col">
    <label [id]="label + random + '-label'"
           [for]="label + random + '-input'"
           class="col-form-label">
      {{label | translate}}:
    </label>
  </div>
  <div class="col-auto">
    <input type="text"
           [id]="label + random + '-input'"
           [attr.name]="name"
           #editableInput="ngModel"
           class="form-control form-control-sm"
           [class.is-invalid]="editableInput.invalid && (editableInput.dirty || editableInput.touched)"
           [(ngModel)]="value"
           (ngModelChange)="onModelChange($event)"
           [pattern]="validation?.pattern!"
           [sasMarkOnSubmit]="formId ?? ''"
           [attr.aria-labelledby]="label + random + '-label'"
           [attr.aria-invalid]="editableInput.invalid && (editableInput.dirty || editableInput.touched)"
           [attr.aria-describedby]="editableInput.invalid ? label + random + '-desc' : null">
    <div class="invalid-feedback" aria-atomic="true" role="alert" [id]="label + random + '-desc'">
      <small>{{templateDrivenFieldService.getFieldErrorMessage(editableInput, validation)}}</small>
    </div>
  </div>
</div>
}
@else {
<div class="d-flex sas-label-value" [class]="sasClass">
  <div class="d-flex align-items-center flex-md-row flex-column justify-content-md-end sas-label-container">
    @if (!hideLabel) {
      <span class="fw-semibold sas-label" [id]="label + random" role="term">{{label | translate}}:</span>
    }
    @if (isOverflowing()) {
      <button type="button"
              class="btn btn-link btn-sm sas-view-all-btn"
              [ngbPopover]="model"
              container="body"
              popoverClass="sas-text-popover"
              [attr.aria-label]="'Expand ' + (label | translate)">
        <i class="bi bi-arrows-angle-expand"></i>
      </button>
    }
  </div>
  <span #sasValue class="overflow-hidden sas-value" role="definition" [attr.aria-labelledby]="!hideLabel ? label + random : null">
    {{model}}
  </span>
</div>
}